import { render, staticRenderFns } from "./PasswordChangeModal.vue?vue&type=template&id=2fe5da7a&scoped=true&"
import script from "./PasswordChangeModal.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChangeModal.vue?vue&type=style&index=0&id=2fe5da7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5da7a",
  null
  
)

export default component.exports